import { DisplayMessage } from "../helpers";
import { DeleteRequest, GetRequest, UpdateRequest } from "../requestHelpers";
import { HttpMethods } from "../../utils/constants";
import {
  DeleteFleetSourceUrl,
  GetFleetSourcesUrl,
  UpdateFleetSourceUrl,
  GetFleetSourceByIdUrl,
  FleetSourceUrl,
  GetDriveBookingPartiesUrl
} from "../../constants/apiUrls";

const handleErrors = async (response) => {
  const result = await response.json();
  if (!response.ok) {
    result.errors.forEach((error) => DisplayMessage(error, "error"));
    return null;
  }
  return result;
};

export const getFleetSources = async () => {
  const response = await GetRequest(GetFleetSourcesUrl());
  return handleErrors(response);
};

export const getFleetSourceById = async (id) => {
  const response = await GetRequest(GetFleetSourceByIdUrl(id));
  return handleErrors(response);
};

export const updateFleetSource = async (id, data) => {
  const response = await UpdateRequest(
    UpdateFleetSourceUrl(id),
    data,
    HttpMethods.Patch
  );
  return handleErrors(response);
};

export const deleteFleetSource = async (id) => {
  const response = await DeleteRequest(DeleteFleetSourceUrl(id));

  if (!response.ok) {
    const result = await response.json();
    result.errors.forEach((error) => DisplayMessage(error, "error"));
  }

  return response.ok;
};

export const createFleetSource = async (data) => {
  const response = await UpdateRequest(
    FleetSourceUrl(),
    data,
    HttpMethods.Post
  );
  return handleErrors(response);
};

export const getDriveParties = async () => {
  const response = await GetRequest(GetDriveBookingPartiesUrl());
  return handleErrors(response);
};

